import React, { useState } from 'react';
import { IonIcon } from '@ionic/react';

const DivisionVisual: React.FC = () => {
    const [currentQuestion, setCurrentQuestion] = useState(generateQuestion());
    const [selectedOption, setSelectedOption] = useState<number | null>(null);
    const [showImage, setShowImage] = useState(false);


    document.title = "Mamas Guidance - Class Two - Mathematics - Division - Visual Problem"; // Set page title

    // Function to generate a random division question
    function generateQuestion() {
        const divisor = Math.floor(Math.random() * 9) + 2; // Random single-digit number (1-9)
        const quotient = Math.floor(Math.random() * 90) + 10; // Random two-digit number (10-99)
        const dividend = divisor * quotient; // Ensure no fractional answers
        const correctAnswer = quotient;

        // Generate options
        const options = new Set<number>();
        options.add(correctAnswer); // Ensure correct answer is included
        while (options.size < 3) {
            options.add(Math.floor(Math.random() * 99) + 1); // Random number between 1-99
        }
        return {
            dividend,
            divisor,
            correctAnswer,
            options: Array.from(options).sort(() => Math.random() - 0.5), // Shuffle options
        };
    }

    // Handle answer selection
    const handleAnswer = (selectedAnswer: number) => {
        setSelectedOption(selectedAnswer);

        if (selectedAnswer === currentQuestion.correctAnswer) {
            setShowImage(true);
            setTimeout(() => {
                setCurrentQuestion(generateQuestion()); // Generate next question
                setShowImage(false);
                setSelectedOption(null);
            }, 5000);
        }
    };

    return (
        <>

            <div className="contentPart">
                {showImage ? (
                    <div className="showMiddle">
                        <img 
                            style={{ height: '150px' }} 
                            className="img-fluid" 
                            src={process.env.REACT_APP_WELDONE_LINK} 
                            alt="Well Done" 
                        />
                    </div>
                ) : (
                    <>
                        <div className="questionArea">
                            <div className='grid-container mb-5'>
                                {/* <div className='grid-box text-right'>
                                    <div className="number-row" style={{opacity:'0'}}>÷</div>
                                    <div className="number-row">÷</div>
                                </div> */}
                                <div className='grid-box text-center'>
                                    <div className="number-row">{currentQuestion.dividend} ÷ {currentQuestion.divisor}</div>
                                </div>
                            </div>
                            {/* <div className='dividerClass'>
                                <hr className="divider" />
                            </div> */}
                            <div className='text-center'>
                                <div className="optionDiv">
                                    {/* <div className='middle-grid'> */}
                                    {currentQuestion.options.map((option, index) => (
                                        <div
                                            key={index}
                                            className={`background-blue ${selectedOption === option
                                                ? option === currentQuestion.correctAnswer
                                                    ? 'correct'
                                                    : 'incorrect'
                                                : ''
                                                }`}
                                            onClick={() => handleAnswer(option)}
                                        >
                                            {option}
                                        </div>
                                    ))}
                                    {/* </div> */}
                                </div>
                            </div>
                        </div>
                        
                    </>
                )}
            </div>
        </>
    );
};

export default DivisionVisual;
